//===========================================//
//    SHUFFLED INK | INIT SLICK CAROUSELS    //
//===========================================//

(function($) {
	$(document).ready(function() {

		/**
		 * Check if page is loading Slick
		 */
		if ( jQuery.fn.slick ) {


			// BREAKPOINTS
			var bp_tiny		= 320;
			var bp_medium	= 640;
			var bp_large	= 1024;
			var bp_xlarge	= 1200;


			//-- HOME SLIDER --//
			$( 'body.home .slider' ).slick({
				autoplay		: true,
				autoplaySpeed	: 6000,
				speed			: 1500,
				pauseOnHover	: false,
			});


			//-- HOME PRODUCTS CAROUSEL --//
			$( '#home-products .carousel' ).slick({
				autoplay		: false,
				infinite		: false,
				arrows			: false,
				dots			: true,
				mobileFirst		: true,
				slidesToShow	: 1,
				responsive		: [
					{
						breakpoint: bp_medium,
						settings: {
							centerMode		: true,
							centerPadding	: '80px',
							initialSlide:	1,
						}
					},
					{
						breakpoint: bp_large,
						settings: {
							slidesToShow:	3,
							slidesToScroll: 3,
						}
					},
				]
			});

			// Match Products Heights
			$(function() {
				$( '#home-products .carousel .slick-slide figure' ).matchHeight();
				$( '#home-products .carousel .slick-slide figcaption p' ).matchHeight();
			});


			//-- LOGO CAROUSEL --//
			$( '.logo-carousel' ).slick({
				autoplay		: true,
				pauseOnHover	: false,
				autoplaySpeed	: 000,
				speed			: 4000,
				arrows			: false,
				centerMode		: true,
				centerPadding	: '75px',
				variableWidth	: true,
			});


			//-- TESTIMONIAL CAROUSEL --//
			$( '.testimonial-carousel' ).slick({
				autoplay		: false,
				autoplaySpeed	: 0,
				speed			: 1000,
				arrows			: false,
				dots			: true,
				slidesToShow	: 1,
			});


			//-- PRODUCT GALLERY --//
			setTimeout( function() { // delay to fix init errors
				$( '#product-help .gallery' ).slick({
					autoplay		: false,
					arrows			: false,
					dots			: true,
					slidesToShow	: 1,
					respondTo		: 'slider',
				});
			}, 1000 );

		} // slick check

	}); // document.ready()
})(jQuery);
